'use strict';
var config = function($window,$log) {
  this.$window=$window;
  this.$log=$log;
  var defaultPredateSelectors={
    'SINGL':{'id':'SINGL','labelen':'1 day','labelnl':'1 dag','labelfr':'1 jour','minEnddateOffset':'0','maxEnddateOffset':'0','order':'0','hraPerHotel':{},'selectFirstEnddate':false,'local':true,'default':true},
    'MULTI':{'id':'MULTI','labelen':'2 days or more','labelnl':'2 dagen of meer','labelfr':'2 jours ou plus','minEnddateOffset':'1','maxEnddateOffset':'31','order':'1','hraPerHotel':{},'selectFirstEnddate':false,'local':true,'default':false}
  };
  this.hosts={
    'localhost': {
      // 'serviceUrl':'http://localhost/outdoor/src/services/index.php',
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'http://localhost/outdoor/src/services/templateimage.php',
      // 'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | HUB',
      'favicon':'https://www.hubruxelles.be/themes/custom/hub_theme/favicon.ico',
      'mode': 'site',
      'ffo':'HU',
      'formbutton': '',
      'url': 'https://hub.sda.be/',
      'urlhash': '5cfc557de0dc19b3128f88b56e8b6d3860c2ef401ff2dd33a375dfa850d8279c',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'undefinedRefererRedirectUrl': {
        'en' : 'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
        'fr' : 'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
        'nl' : 'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures'
      },
      'finishedRedirect': {
        'en':'https://hub.sda.be/confirmation/en/',
        'nl':'https://hub.sda.be/confirmation/nl/',
        'fr':'https://hub.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo HUB',
        'src':'https://hub.talentfinder.be/Ressources/Templates/Frontend/HUB2023/Ressources/Images/logos/logo-hub-simplified.svg',
        'href':{
          'en':'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
          'nl':'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
          'fr':'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures'
        }
      },
      'partner':'HUB',
      'referrerUrl':''
    },
    'kiosk.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'ctepHttpProtocol':'https',
      'ctepWsProtocol':'wss',
      'devIsAvailable':false,
      'ctepScript':'ctepForKiosk',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'mode':'kiosk',
      'ffo':'AV',
      'formbutton': '',
      'url': 'https://kiosk.sda.be/',
      'urlhash': '2d1e82eefff5ebe04c264242e22d69b62a8eb0a8d6f64b21333143f537a37b93',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'finishedRedirect': {},
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'/assets/images/logo-adventure-valley.svg',
        'href':{
          'en': 'https://www.adventure-valley.be/en',
          'nl': 'https://www.adventure-valley.be/nl',
          'fr': 'https://www.adventure-valley.be'
        }
      },
      'onlineDiscountMessage':{}
    },
    'booking.adventure-valley.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Adventure-valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'AV',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/',
      'urlhash': '7bd9655b54f1c1e1f5ccb0ee15efb12f9a1ec0700ceb8a7d719db039de623569',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.adventure-valley.be/en/park-rules',
          'nl': 'https://www.adventure-valley.be/nl/verkoop-en-parkreglement',
          'fr': 'https://www.adventure-valley.be/reglementation-des-ventes-et-des-parcs'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'proposePromotionPayment':true,
      'showPricekeyOptions':true,
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'/assets/images/logo-adventure-valley.svg',
        'href':{
          'en': 'https://www.adventure-valley.be/en',
          'nl': 'https://www.adventure-valley.be/nl',
          'fr': 'https://www.adventure-valley.be'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors': {'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.adventure-valley.be/birthdays/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Adventure-valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'AB',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/birthdays/',
      'urlhash': 'e8691f50cc0f671ede5d420b65cbbfb0c6881f5903db9976df4d5821f911dd31',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.adventure-valley.be/en/park-rules',
          'nl': 'https://www.adventure-valley.be/nl/verkoop-en-parkreglement',
          'fr': 'https://www.adventure-valley.be/reglementation-des-ventes-et-des-parcs'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'proposePromotionPayment':true,
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'/assets/images/logo-adventure-valley.svg',
        'href':{
          'en': 'https://www.adventure-valley.be/en',
          'nl': 'https://www.adventure-valley.be/nl',
          'fr': 'https://www.adventure-valley.be'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors': {'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.adventure-valley.be/winter/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Winter Valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'WV',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/winter/',
      'urlhash': '1f426c2331861a8bb6e4405808987afb237aa55d1d206a6558c2621145b3287b',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.adventure-valley.be/en/park-rules',
          'nl': 'https://www.adventure-valley.be/nl/verkoop-en-parkreglement',
          'fr': 'https://www.adventure-valley.be/reglementation-des-ventes-et-des-parcs'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'proposePromotionPayment':true,
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'https://cdn.prod.website-files.com/655b319bc30c0afb0e87c5c1/691459948ccba848f677ff03_6b4c8b8c13b3b51d0b89131d5ae64570_logo%20winter2_big.avif',
        'href':{
          'en': 'https://winter.adventure-valley.be/',
          'nl': 'https://nl.winter.adventure-valley.be/',
          'fr': 'https://winter.adventure-valley.be/'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors': {'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.adventure-valley.be/giftcard/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Adventure-valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'GA',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/giftcard/',
      'urlhash': 'f2b6dbd60000fc15253f69df22d54bfe1c762baaaebdac4297b6c4930f97cfd1',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.adventure-valley.be/en/park-rules',
          'nl': 'https://www.adventure-valley.be/nl/verkoop-en-parkreglement',
          'fr': 'https://www.adventure-valley.be/reglementation-des-ventes-et-des-parcs'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'skipDatesPage':true,
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'/assets/images/logo-adventure-valley.svg',
        'href':{
          'en': 'https://www.adventure-valley.be/en',
          'nl': 'https://www.adventure-valley.be/nl',
          'fr': 'https://www.adventure-valley.be'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.adventure-valley.be/company-giftcard/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Adventure-valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'GB',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/company-giftcard/',
      'urlhash': '59ddf0e356e68e933dce0fb1fb92c5c6cce34ccdd6f70fb7ebb8efd305502611',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.adventure-valley.be/en/park-rules',
          'nl': 'https://www.adventure-valley.be/nl/verkoop-en-parkreglement',
          'fr': 'https://www.adventure-valley.be/reglementation-des-ventes-et-des-parcs'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'skipDatesPage':true,
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'/assets/images/logo-adventure-valley.svg',
        'href':{
          'en': 'https://www.adventure-valley.be/en',
          'nl': 'https://www.adventure-valley.be/nl',
          'fr': 'https://www.adventure-valley.be'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.adventure-valley.be/vivalia/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | Vivalia',
      'favicon':'https://www.vivalia.be/sites/default/files/favicon_0.png',
      'mode': 'site',
      'ffo':'VI',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/vivalia/',
      'urlhash': 'd98a80b59ced18e532d32ae2f8dc0062ac6b58cfdd9b95e68aea5951de19f125',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'finishedRedirect': {
        'en':'https://booking.adventure-valley.be/vivalia/confirmation/en/confirmation.html',
        'nl':'https://booking.adventure-valley.be/vivalia/confirmation/nl/bevestiging.html',
        'fr':'https://booking.adventure-valley.be/vivalia/confirmation/index.html'
      },
      'logo': {
        'alt':'Logo Vivalia',
        'src':' https://www.vivalia.be/themes/vivalia_theme/logo.svg',
        'href':{
          'en':'https://www.vivalia.be/',
          'nl':'https://www.vivalia.be/',
          'fr':'https://www.vivalia.be/'
        }
      },
      'partner':'VIV',
      'showSalutation':true,
      'allowOwningcontactIsCompany':false,
      'predateSelectors': {'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.adventure-valley.be/montdespins/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | Mont-des-Pins',
      'favicon':'https://montdespins.be/wp-content/uploads/2021/06/cropped-nz-icoon-192x192.png',
      'mode': 'site',
      'ffo':'MP',
      'formbutton': '',
      'url': 'https://booking.adventure-valley.be/montdespins/',
      'urlhash': '38331de41ce67bcc89c1b6d128224791e9dd2663bef14e9fb98aae16129b43a5',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en':'https://booking.adventure-valley.be/montdespins/confirmation/en/confirmation.html',
        'nl':'https://booking.adventure-valley.be/montdespins/confirmation/nl/bevestiging.html',
        'fr':'https://booking.adventure-valley.be/montdespins/confirmation/index.html'
      },
      'logo': {
        'alt':'Logo Mont-des-Pins',
        'src':' https://dennenheuvel.be/wp-content/uploads/2021/06/mont-des-pins-logo1.svg',
        'href':{
          'en':'https://montdespins.be/',
          'nl':'https://montdespins.be/',
          'fr':'https://montdespins.be/'
        }
      },
      'predateSelectors': {'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking-halloween.adventure-valley.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Adventure-valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'MV',
      'formbutton': '',
      'url': 'https://booking-halloween.adventure-valley.be/',
      'urlhash': '57a12268bccd946b2b0a0b148292a3955fff727bcae6073c16299bdbf739a5da',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en':'https://www.adventure-valley.be/en/disclaimer',
          'nl':'https://www.adventure-valley.be/nl/juridische-vermeldingen',
          'fr':'https://www.adventure-valley.be/mentions-legales'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en':'https://www.adventure-valley.be/en/cookies',
          'nl':'https://www.adventure-valley.be/nl/cookies',
          'fr':'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'proposePromotionPayment':true,
      'logo': {
        'alt':'Logo Halloween Adventure Valley',
        'src':'https://cdn.prod.website-files.com/612e493f669f4894c189b017/64e7205ec1ffedd5255296f4_logoweb2023%20(1).png',
        'href':{'en':'https://halloween.adventure-valley.be/','nl':'https://nl.halloween.adventure-valley.be/','fr':'https://halloween.adventure-valley.be/'}
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'stages.adventure-valley.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.adventure-valley.be',
        'fallbackURL':'https://load.sst.adventure-valley.be',
        'scriptId':'6zjhknmfdfr',
        'queryParams':'bpcuc=aWQ9R1RNLUs0SEpNTFE%3D&page=2',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Adventure-valley',
      'favicon':'https://www.adventure-valley.be/sites/advv.be/themes/custom/advv_theme/favicon.ico',
      'mode': 'site',
      'ffo':'SA',
      'formbutton':'',
      'url': 'https://stages.adventure-valley.be/',
      'urlhash': '301884fe86bed1aad8ea6f5b85ccf9cefb8f55291677f011ba92ebcd30f3e438',
      'promoCode': '',
      'termsAndConditionsLinks': [
        {
          'label': {
            'en': 'the terms and conditions',
            'nl': 'de algemene voorwaarden',
            'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
          },
          'href': {
            'en': 'https://www.adventure-valley.be/en/general-terms',
            'nl': 'https://www.adventure-valley.be/nl/algemene-huurvoorwaarden',
            'fr': 'https://www.adventure-valley.be/conditions-generales-location'
          }
        }
      ],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en': 'https://www.adventure-valley.be/en/thank-you-your-payment',
        'nl': 'https://www.adventure-valley.be/nl/inschrijving-voor-de-dagkampen',
        'fr': 'https://www.adventure-valley.be/merci-pour-votre-paiement'
      },
      'proposeVoucherPayment': true,
      'logo': {
        'alt':'Logo Adventure Valley',
        'src':'/assets/images/logo-adventure-valley.svg',
        'href':{
          'en': 'https://www.adventure-valley.be/en/',
          'nl': 'https://www.adventure-valley.be/nl/',
          'fr': 'https://www.adventure-valley.be/'
        }
      },
      'onlineDiscountMessage': {
        'en': 'reduction on activities when paid online',
        'nl': 'korting op activiteiten indien u online betaalt',
        'fr': 'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'
      },
      'predateSelectors': {}
    },
    'ardennes-etape.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | Ardennes Étape',
      'favicon':'https://fr.ardennes-etape.be/images/favIcon/favicon.ico',
      'mode': 'site',
      'ffo':'AE',
      'formbutton':'',
      'url': 'https://ardennes-etape.sda.be/',
      'urlhash': 'b4833caa0b04d447a0000bb0cc6f4c8d27c4a622ceda5e3bf5fc259f2e9b8d2a',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'finishedRedirect': {
        'en':'https://ardennes-etape.sda.be/confirmation/en/',
        'nl':'https://ardennes-etape.sda.be/confirmation/nl/',
        'fr':'https://ardennes-etape.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo Ardennes Etape',
        'src':'/assets/images/logo-ardennes-etape.svg',
        'href':{
          'en':'https://en.ardennes-etape.be/',
          'nl':'https://www.ardennes-etape.be/',
          'fr':'https://fr.ardennes-etape.be/'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL},
      'partner':'AET'
    },
    'booking.sda.be/shop/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | Shop Vieile Ville',
      'favicon':'https://cdn.prod.website-files.com/663b4cf83ad1a6c07d21bf9a/6890856945374302d31ad55e_Design%20sans%20titre%20(27).png',
      'mode': 'site',
      'ffo':'CS',
      'formbutton': '',
      'url': 'https://booking.sda.be/shop/',
      'urlhash': '59ddf0e356e68e933dce0fb1fb92c5c6cce34ccdd6f70fb7ebb8efd305502611',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.adventure-valley.be/en/park-rules',
          'nl': 'https://www.adventure-valley.be/nl/verkoop-en-parkreglement',
          'fr': 'https://www.adventure-valley.be/reglementation-des-ventes-et-des-parcs'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.adventure-valley.be/en/cookies',
          'nl': 'https://www.adventure-valley.be/nl/cookies',
          'fr': 'https://www.adventure-valley.be/cookies'
        }
      },
      'finishedRedirect': {
        'en':'https://www.adventure-valley.be/en/activityconfirmation',
        'nl':'https://www.adventure-valley.be/nl/activiteitbevestiging',
        'fr':'https://www.adventure-valley.be/activiteconfirmation'
      },
      'proposeVoucherPayment':true,
      'skipDatesPage':true,
      'logo': {
        'alt':'Logo SDA',
        'src':'https://cdn.prod.website-files.com/663b4cf83ad1a6c07d21bf9a/6890c6cf782dc3ba909447f9_SDA_alternative_brown.png',
        'href':{
          'en': 'https://www.sda.be/en',
          'nl': 'https://www.sda.be/nl',
          'fr': 'https://www.sda.be'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'cera.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | CERA',
      'favicon':'https://www.cera.coop/favicon.ico?v=504911232000000000',
      'mode': 'site',
      'ffo':'CE',
      'formbutton': '',
      'url': 'https://cera.sda.be/',
      'urlhash': '62c94dad895214a49e654c8f77dffaba95d7fe5151c1ccf1a464899721205b55',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'undefinedRefererRedirectUrl': {
        'en' : 'https://www.cera.coop/fr/particuliers/profitez-des-avantages/chercher-un-avantage/durbuy-2025_d218c3dec36542c99b498b21f9fbe724',
        'fr' : 'https://www.cera.coop/fr/particuliers/profitez-des-avantages/chercher-un-avantage/durbuy-2025_d218c3dec36542c99b498b21f9fbe724',
        'nl' : 'https://www.cera.coop/nl/particulieren/genieten-van-voordelen/voordelen-zoeken/durbuy-2025_d218c3dec36542c99b498b21f9fbe724'
      },
      'finishedRedirect': {
        'en':'https://cera.sda.be/confirmation/en/',
        'nl':'https://cera.sda.be/confirmation/nl/',
        'fr':'https://cera.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo CERA',
        'src':'/assets/images/logo-cera.svg',
        'href':{
          'en':'https://www.cera.coop/fr/particuliers',
          'nl':'https://www.cera.coop/fr/particuliers',
          'fr':'https://www.cera.coop/fr/particuliers'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'partner':'CER',
      'referrerUrl':[
        'https://avantages.cera.coop/',
        'https://voordelen.cera.coop/',
        'https://vorteile.cera.coop/',
        'https://www.cera.coop/'
      ]
    },
    'cera.sda.be/adventure-valley/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | CERA',
      'favicon':'https://www.cera.coop/favicon.ico?v=504911232000000000',
      'mode': 'site',
      'ffo':'CA',
      'formbutton': '',
      'url': 'https://cera.sda.be/adventure-valley/',
      'urlhash': 'a9f0bd6adc416d5c36ad99897a56cf957170a23459a7c96182f9b9b396d63cb9',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'undefinedRefererRedirectUrl': {
        'en' : 'https://www.cera.coop/fr/particuliers/profitez-des-avantages/chercher-un-avantage/adventure-valley-2025_b3a2d11a439749f5afac42c01a911b9f',
        'fr' : 'https://www.cera.coop/fr/particuliers/profitez-des-avantages/chercher-un-avantage/adventure-valley-2025_b3a2d11a439749f5afac42c01a911b9f',
        'nl' : 'https://www.cera.coop/nl/particulieren/genieten-van-voordelen/voordelen-zoeken/adventure-valley-2025_b3a2d11a439749f5afac42c01a911b9f'
      },
      'finishedRedirect': {
        'en':'https://cera.sda.be/confirmation/en/',
        'nl':'https://cera.sda.be/confirmation/nl/',
        'fr':'https://cera.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo CERA',
        'src':'/assets/images/logo-cera.svg',
        'href':{
          'en':'https://www.cera.coop/fr/particuliers',
          'nl':'https://www.cera.coop/fr/particuliers',
          'fr':'https://www.cera.coop/fr/particuliers'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'partner':'CER',
      'referrerUrl':[
        'https://avantages.cera.coop/',
        'https://voordelen.cera.coop/',
        'https://vorteile.cera.coop/',
        'https://www.cera.coop/'
      ]
    },
    'hub.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | HUB',
      'favicon':'https://www.hubruxelles.be/themes/custom/hub_theme/favicon.ico',
      'mode': 'site',
      'ffo':'HU',
      'formbutton': '',
      'url': 'https://hub.sda.be/',
      'urlhash': '5cfc557de0dc19b3128f88b56e8b6d3860c2ef401ff2dd33a375dfa850d8279c',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'undefinedRefererRedirectUrl': {
        'en' : 'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
        'fr' : 'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
        'nl' : 'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures'
      },
      'finishedRedirect': {
        'en':'https://hub.sda.be/confirmation/en/',
        'nl':'https://hub.sda.be/confirmation/nl/',
        'fr':'https://hub.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo HUB',
        'src':'https://hub.talentfinder.be/Ressources/Templates/Frontend/HUB2023/Ressources/Images/logos/logo-hub-simplified.svg',
        'href':{
          'en':'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
          'nl':'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures',
          'fr':'https://intranet.hubruxelles.be/fr/avantage-parc-durbuy-aventures'
        }
      },
      'partner':'HUB',
      'referrerUrl':'https://intranet.hubruxelles.be/'
    },
    'myedenred.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | Edenred',
      'favicon':'https://myedenred.be/favicon.ico',
      'mode': 'site',
      'ffo':'ED',
      'formbutton': '',
      'url': 'https://myedenred.sda.be/',
      'urlhash': '5cfc557de0dc19b3128f88b56e8b6d3860c2ef401ff2dd33a375dfa850d8279c',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'undefinedRefererRedirectUrl': {
        'en' : 'https://myedenred.be/',
        'fr' : 'https://myedenred.be/',
        'nl' : 'https://myedenred.be/'
      },
      'finishedRedirect': {
        'en':'https://myedenred.sda.be/confirmation/en/',
        'nl':'https://myedenred.sda.be/confirmation/nl/',
        'fr':'https://myedenred.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo Edenred',
        'src':'https://myedenred.be/Workspace/dist/myedenred/Content/images/logoMyEdenred.svg',
        'href':{
          'en':'https://myedenred.be/',
          'nl':'https://myedenred.be/',
          'fr':'https://myedenred.be/'
        }
      },
      'partner':'EDE',
      'referrerUrl':'https://myedenred.be/'
    },
    'railfacilities.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | Rail Facilities',
      'favicon':'https://railfacilities.be/SemanticTheme/railfacilities-logo.png',
      'mode': 'site',
      'ffo':'RF',
      'formbutton': '',
      'url': 'https://railfacilities.sda.be/',
      'urlhash': '93719c6d41e6feb2b15318409087844418fad2c23e707ec967c9a9aee3f32d0d',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':false,
      'undefinedRefererRedirectUrl': {
        'en' : 'https://railfacilities.be/login',
        'fr' : 'https://railfacilities.be/login',
        'nl' : 'https://railfacilities.be/login'
      },
      'finishedRedirect': {
        'en':'https://railfacilities.sda.be/confirmation/en/',
        'nl':'https://railfacilities.sda.be/confirmation/nl/',
        'fr':'https://railfacilities.sda.be/confirmation/'
      },
      'logo': {
        'alt':'Logo Rail Facilities',
        'src':'https://railfacilities.be/SemanticTheme/railfacilities-logo.png',
        'href':{
          'en':'https://railfacilities.be/',
          'nl':'https://railfacilities.be/',
          'fr':'https://railfacilities.be/'
        }
      },
      'partner':'RFC',
      'referrerUrl':'https://railfacilities.be/'
    },
    'ah.sda.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-M4WSH68',
        'uidSource':false
      },
      'title':'Booking | AH',
      'favicon':'https://www.ah.be/favicon.ico',
      'mode': 'site',
      'ffo':'AH',
      'formbutton': '',
      'url': 'https://ah.sda.be/',
      'urlhash': 'c54f1073b5eae3b1df1d47deda529b26982ad6763f8612eac245f26c4dc916c1',
      'promoCode': '',
      'termsAndConditionsLinks':[],
      'privacyLink':null,
      'proposeVoucherPayment':true,
      'undefinedRefererRedirectUrl': {
        'en':'https://www.ah.be/',
        'nl':'https://www.ah.be/',
        'fr':'https://www.ah.be/'
      },
      'finishedRedirect': {
        'en':'https://ah.sda.be/confirmation/en/confirmation.html',
        'nl':'https://ah.sda.be/confirmation/nl/bevestiging.html',
        'fr':'https://ah.sda.be/confirmation/index.html'
      },
      'logo': {
        'alt':'Logo AH',
        'src':'https://static.ah.nl/ah-static/images/ah-ui-bridge-components/logo/logo-ah.svg',
        'href':{
          'en':'https://www.ah.be/',
          'nl':'https://www.ah.be/',
          'fr':'https://www.ah.be/'
        }
      },
      'predateSelectors': {'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.durbuyproperties.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-TVBF979',
        'uidSource':false
      },
      'title':'Booking | Durbuy Properties',
      'favicon':'https://www.durbuyproperties.be/favicon-16x16.png',
      'mode': 'site',
      'ffo': 'SE',
      'formbutton': '',
      'url': 'https://booking.durbuyproperties.be/',
      'urlhash': 'bffa6441c411166825191ee0642c7bb9ab59898dfadc8202855ab5049940d4dd',
      'promoCode': '',
      'termsAndConditionsLinks': [
        {
          'label': {
            'en': 'the terms and conditions',
            'nl': 'de algemene voorwaarden',
            'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
          },
          'href': {
            'en': 'https://www.durbuyproperties.be/mentions-legales',
            'nl': 'https://www.durbuyproperties.be/nl/juridische-vermeldingen',
            'fr': 'https://www.durbuyproperties.be/mentions-legales'
          }
        }
      ],
      'proposeVoucherPayment': true,
      'finishedRedirect': {
        'en': 'https://www.durbuyproperties.be/confirmation-reservation',
        'nl': 'https://www.durbuyproperties.be/nl/boekingsbevestiging',
        'fr': 'https://www.durbuyproperties.be/confirmation-reservation'
      },
      'logo': {
        'alt':'Logo Durbuy Properties',
        'src':'/assets/images/logo-durbuy-properties.svg',
        'href':{
          'en':'https://www.durbuyproperties.be/',
          'nl':'https://www.durbuyproperties.be/nl/',
          'fr':'https://www.durbuyproperties.be/'
        }
      },
      'onlineDiscountMessage': {
        'en': 'reduction on activities when paid online',
        'nl': 'korting op activiteiten indien u online betaalt',
        'fr': 'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'
      },
      'predateSelectors':{}
    },
    'booking.durbuygreenfields.com': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.durbuygreenfields.com',
        'fallbackURL':'https://load.sst.durbuygreenfields.com',
        'scriptId':'38wnjndbsoll',
        'queryParams':'75en9pps=aWQ9R1RNLTVXUUdaMlQ%3D&page=3',
        'uidSource':false
      },
      'mode': 'site',
      'ffo':'TM',
      'title':'Booking | Durbuy Green Fields',
      'favicon':'https://assets-global.website-files.com/65a540a98a6d966688fd0407/65dc733fdfa5598c371f391e_favicon.png',
      'formbutton': '',
      'url': 'https://booking.durbuygreenfields.com/',
      'urlhash': 'e69ff54cab7cfd680dfaaa272cf4e8831e5d3f4b702311a7822b53a5cda3b217',
      'promoCode': '',
      'termsAndConditionsLinks': [
        {
          'label': {
            'en': 'the terms and conditions',
            'nl': 'de algemene voorwaarden',
            'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
          },
          'href': {
            'en': 'https://en.durbuygreenfields.com/mentions-legales',
            'nl': 'https://nl.durbuygreenfields.com/mentions-legales',
            'fr': 'https://www.durbuygreenfields.com/mentions-legales'
          }
        }
      ],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://en.durbuygreenfields.com/cookies',
          'nl': 'https://nl.durbuygreenfields.com/cookies',
          'fr': 'https://www.durbuygreenfields.com/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'proposePromotionPayment':true,
      'finishedRedirect': {
        'en': 'https://en.durbuygreenfields.com/confirmation-de-votre-reservation',
        'nl': 'https://nl.durbuygreenfields.com/confirmation-de-votre-reservation',
        'fr': 'https://www.durbuygreenfields.com/confirmation-de-votre-reservation'
      },
      'logo': {
        'alt':'Logo Durbuy Green Fields',
        'src':'/assets/images/logo-greenfields.svg',
        'href':{
          'en':'https://en.durbuygreenfields.com/',
          'nl':'https://nl.durbuygreenfields.com/',
          'fr':'https://www.durbuygreenfields.com/?no_redirect=true'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'MULTI':defaultPredateSelectors.MULTI}
    },
    'booking.durbuygreenfields.com/giftcard/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.durbuygreenfields.com',
        'fallbackURL':'https://load.sst.durbuygreenfields.com',
        'scriptId':'38wnjndbsoll',
        'queryParams':'75en9pps=aWQ9R1RNLTVXUUdaMlQ%3D&page=3',
        'uidSource':false
      },
      'mode': 'site',
      'ffo':'TG',
      'title':'Booking | Durbuy Green Fields',
      'favicon':'https://assets-global.website-files.com/65a540a98a6d966688fd0407/65dc733fdfa5598c371f391e_favicon.png',
      'formbutton': '',
      'url': 'https://booking.durbuygreenfields.com/giftcard/',
      'urlhash': '6de181a4e4142105ee2d5bd783212b2d092b0eac2d6c802e28b31b3742d36f45',
      'promoCode': '',
      'termsAndConditionsLinks': [
        {
          'label': {
            'en': 'the terms and conditions',
            'nl': 'de algemene voorwaarden',
            'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
          },
          'href': {
            'en': 'https://en.durbuygreenfields.com/mentions-legales',
            'nl': 'https://nl.durbuygreenfields.com/mentions-legales',
            'fr': 'https://www.durbuygreenfields.com/mentions-legales'
          }
        }
      ],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://en.durbuygreenfields.com/cookies',
          'nl': 'https://nl.durbuygreenfields.com/cookies',
          'fr': 'https://www.durbuygreenfields.com/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'skipDatesPage':true,
      'finishedRedirect': {
        'en': 'https://en.durbuygreenfields.com/confirmation-de-votre-reservation',
        'nl': 'https://nl.durbuygreenfields.com/confirmation-de-votre-reservation',
        'fr': 'https://www.durbuygreenfields.com/confirmation-de-votre-reservation'
      },
      'logo': {
        'alt':'Logo Durbuy Green Fields',
        'src':'/assets/images/logo-greenfields.svg',
        'href':{
          'en':'https://en.durbuygreenfields.com/',
          'nl':'https://nl.durbuygreenfields.com/',
          'fr':'https://www.durbuygreenfields.com/?no_redirect=true'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.durbuygreenfields.com/monizze/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.durbuygreenfields.com',
        'fallbackURL':'https://load.sst.durbuygreenfields.com',
        'scriptId':'38wnjndbsoll',
        'queryParams':'75en9pps=aWQ9R1RNLTVXUUdaMlQ%3D&page=3',
        'uidSource':false
      },
      'mode': 'site',
      'ffo':'MO',
      'title':'Booking | Monizze',
      'favicon':'https://account.monizze.be/favicon-monizze.png',
      'formbutton': '',
      'url': 'https://booking.durbuygreenfields.com/monizze/',
      'urlhash': 'bc04e96e42b76c1714ed3f10f7f384a470af2c091dc972f99321cdbda8fbbbe6',
      'promoCode': '',
      'undefinedRefererRedirectUrl': {
        'en' : 'https://account.monizze.be/login/email',
        'fr' : 'https://account.monizze.be/login/email',
        'nl' : 'https://account.monizze.be/login/email'
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://en.durbuygreenfields.com/confirmation-de-votre-reservation',
        'nl': 'https://nl.durbuygreenfields.com/confirmation-de-votre-reservation',
        'fr': 'https://www.durbuygreenfields.com/confirmation-de-votre-reservation'
      },
      'logo': {
        'alt':'Logo Monizze',
        'src':'https://account.monizze.be/monizze_logo.svg',
        'href':{
          'en' : 'https://account.monizze.be/login/email',
          'fr' : 'https://account.monizze.be/login/email',
          'nl' : 'https://account.monizze.be/login/email'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'MULTI':defaultPredateSelectors.MULTI},
      'partner':'MON'
    },
    'padel.durbuygreenfields.com': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.durbuygreenfields.com',
        'fallbackURL':'https://load.sst.durbuygreenfields.com',
        'scriptId':'38wnjndbsoll',
        'queryParams':'75en9pps=aWQ9R1RNLTVXUUdaMlQ%3D&page=3',
        'uidSource':false
      },
      'mode': 'site',
      'ffo':'PD',
      'title':'Padel | Durbuy Green Fields',
      'favicon':'https://assets-global.website-files.com/65a540a98a6d966688fd0407/65dc733fdfa5598c371f391e_favicon.png',
      'formbutton': '',
      'url': 'https://padel.durbuygreenfields.com/',
      'urlhash': '96c8a13b9fa4e7db9a461f4b655c38050086c0b5f3df8bd02b86a420fb17936b',
      'promoCode': '',
      'termsAndConditionsLinks': [
        {
          'label': {
            'en': 'the terms and conditions',
            'nl': 'de algemene voorwaarden',
            'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
          },
          'href': {
            'en': 'https://en.durbuygreenfields.com/mentions-legales',
            'nl': 'https://nl.durbuygreenfields.com/mentions-legales',
            'fr': 'https://www.durbuygreenfields.com/mentions-legales'
          }
        }
      ],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://en.durbuygreenfields.com/cookies',
          'nl': 'https://nl.durbuygreenfields.com/cookies',
          'fr': 'https://www.durbuygreenfields.com/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://en.durbuygreenfields.com/confirmation-de-votre-reservation',
        'nl': 'https://nl.durbuygreenfields.com/confirmation-de-votre-reservation',
        'fr': 'https://www.durbuygreenfields.com/confirmation-de-votre-reservation'
      },
      'logo': {
        'alt':'Logo Durbuy Green Fields',
        'src':'/assets/images/logo-greenfields.svg',
        'href':{
          'en':'https://en.durbuygreenfields.com/',
          'nl':'https://nl.durbuygreenfields.com/',
          'fr':'https://www.durbuygreenfields.com/?no_redirect=true'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.duveldome.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-W88SHPV',
        'uidSource':false
      },
      'title':'Booking | Durbuy Properties',
      'favicon':'/assets/images/favicon/duveldome/favicon-16x16.png',
      'mode': 'site',
      'ffo':'DH',
      'formbutton': '',
      'url': 'https://booking.duveldome.be/',
      'urlhash': '23877c1b57642a2fcd37fe21f80f68d2328ddbbcfd62ea1eed78b0b026a6d928',
      'promoCode': '',
      'termsAndConditionsLinks': [
        {
          'label': {
            'en': 'the terms and conditions',
            'nl': 'de algemene voorwaarden',
            'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
          },
          'href': {
            'en': 'https://www.duveldome.be/en/disclaimer',
            'nl': 'https://www.duveldome.be/nl/juridische-vermeldingen',
            'fr': 'https://www.duveldome.be/mentions-legales'
          }
        }
      ],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://www.duveldome.be/en/cookies',
          'nl': 'https://www.duveldome.be/nl/cookies',
          'fr': 'https://www.duveldome.be/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://www.duveldome.be/en/booking-confirmation',
        'nl': 'https://www.duveldome.be/nl/boekingsbevestiging',
        'fr': 'https://www.duveldome.be/confirmation-de-reservation'
      },
      'logo': {
        'alt':'Logo Duvel Dome',
        'src':'/assets/images/logo-duveldome.svg',
        'href':{
          'en':'https://www.duveldome.be/en/',
          'nl':'https://www.duveldome.be/nl/',
          'fr':'https://www.duveldome.be/'
        }
      },
      'onlineDiscountMessage': {
        'en': 'reduction on activities when paid online',
        'nl': 'korting op activiteiten indien u online betaalt',
        'fr': 'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'
      },
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.fivenationsdurbuy.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-5KHF7R4',
        'uidSource':false
      },
      'title':'Booking | Five Nations Durbuy',
      'favicon':'https://www.fivenationsdurbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo': 'FI',
      'formbutton': '',
      'url': 'https://booking.fivenationsdurbuy.be/',
      'urlhash': 'a0c80aa54e03b2f2b63c6ec1741edeadf515c6c40605a74b4fb23d8dc1836f8b',
      'promoCode': '',
      'termsAndConditionsLinks': [{
        'label': {
          'en': 'the terms and conditions',
          'nl': 'de algemene voorwaarden',
          'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href': {
          'en': 'https://www.fivenationsdurbuy.be/en/mentions-legales',
          'nl': 'https://www.fivenationsdurbuy.be/nl/mentions-legales',
          'fr': 'https://www.fivenationsdurbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink': {
        'label': {'en': 'privacy', 'nl': 'privacy', 'fr': 'vie priv\u00E9e'},
        'href': {
          'en': 'https://www.fivenationsdurbuy.be/en/gdpr',
          'nl': 'https://www.fivenationsdurbuy.be/nl/gdpr',
          'fr': 'https://www.fivenationsdurbuy.be/fr/gdpr'
        }
      },
      'proposeVoucherPayment': true,
      'finishedRedirect': {
        'en': 'https://www.fivenationsdurbuy.be/en/confirmation',
        'nl': 'https://www.fivenationsdurbuy.be/nl/bevestiging',
        'fr': 'https://www.fivenationsdurbuy.be/fr/confirmation'
      },
      'logo': {
        'alt':'Logo Fivenations',
        'src':'/assets/images/logo-fivenations.svg',
        'href':{'en':'https://www.fivenationsdurbuy.be/en','nl':'https://www.fivenationsdurbuy.be/nl','fr':'https://www.fivenationsdurbuy.be/fr'}
      },
      'onlineDiscountMessage': {'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'MULTI':defaultPredateSelectors.MULTI}
    },
    'booking.golfdurbuy.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-5KHF7R4',
        'uidSource':false
      },
      'title':'Booking | Durbuy Golf Resorts',
      'favicon':'https://www.golfdurbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo': 'FI',
      'formbutton': '',
      'url': 'https://booking.golfdurbuy.be/',
      'urlhash': 'efb802407bad5d2ff20c6d38cd4373fda1881e7433e7faece20bd0bf433222b9',
      'promoCode': '',
      'termsAndConditionsLinks': [{
        'label': {
          'en': 'the terms and conditions',
          'nl': 'de algemene voorwaarden',
          'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href': {
          'en': 'https://www.golfdurbuy.be/en/mentions-legales',
          'nl': 'https://www.golfdurbuy.be/nl/mentions-legales',
          'fr': 'https://www.golfdurbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink': {
        'label': {'en': 'privacy', 'nl': 'privacy', 'fr': 'vie priv\u00E9e'},
        'href': {
          'en': 'https://www.golfdurbuy.be/en/gdpr',
          'nl': 'https://www.golfdurbuy.be/nl/gdpr',
          'fr': 'https://www.golfdurbuy.be/fr/gdpr'
        }
      },
      'proposeVoucherPayment': true,
      'finishedRedirect': {
        'en': 'https://www.golfdurbuy.be/en/confirmation',
        'nl': 'https://www.golfdurbuy.be/nl/bevestiging',
        'fr': 'https://www.golfdurbuy.be/fr/confirmation'
      },
      'logo': {
        'alt':'Logo Durbuy Golf Resorts',
        'src':'/assets/images/logo-golfdurbuy.svg',
        'href':{'en':'https://www.golfdurbuy.be/en','nl':'https://www.golfdurbuy.be/nl','fr':'https://www.golfdurbuy.be/fr'}
      },
      'onlineDiscountMessage': {'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'MULTI':defaultPredateSelectors.MULTI}
    },
    'booking.golfdurbuy.be/hivernales/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-5KHF7R4',
        'uidSource':false
      },
      'title':'Booking | Les Hivernales',
      'favicon':'https://www.golfdurbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo': 'HV',
      'formbutton': '',
      'url': 'https://booking.golfdurbuy.be/hivernales/',
      'urlhash': '56434136c369f6cd1a49046d10f075b5b551cd85875d1bbe66ccbbcf929a18f9',
      'promoCode': '',
      'termsAndConditionsLinks': [{
        'label': {
          'en': 'the terms and conditions',
          'nl': 'de algemene voorwaarden',
          'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href': {
          'en': 'https://www.golfdurbuy.be/en/mentions-legales',
          'nl': 'https://www.golfdurbuy.be/nl/mentions-legales',
          'fr': 'https://www.golfdurbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink': {
        'label': {'en': 'privacy', 'nl': 'privacy', 'fr': 'vie priv\u00E9e'},
        'href': {
          'en': 'https://www.golfdurbuy.be/en/gdpr',
          'nl': 'https://www.golfdurbuy.be/nl/gdpr',
          'fr': 'https://www.golfdurbuy.be/fr/gdpr'
        }
      },
      'proposeVoucherPayment': true,
      'finishedRedirect': {
        'en': 'https://www.golfdurbuy.be/en/confirmation',
        'nl': 'https://www.golfdurbuy.be/nl/bevestiging',
        'fr': 'https://www.golfdurbuy.be/fr/confirmation'
      },
      'logo': {
        'alt':'Logo Durbuy Golf Resorts',
        'src':'/assets/images/logo-golfdurbuy.svg',
        'href':{'en':'https://www.golfdurbuy.be/en','nl':'https://www.golfdurbuy.be/nl','fr':'https://www.golfdurbuy.be/fr'}
      },
      'onlineDiscountMessage': {'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.lelabyrinthe.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://sst.lelabyrinthe.be',
        'fallbackURL':'https://load.sst.lelabyrinthe.be',
        'scriptId':'2horvbbapzm',
        'queryParams':'14=aWQ9R1RNLVc4MjhWMko%3D&apiKey=96d56acc',
        'uidSource':'stapeUserId'
      },
      'title':'Booking | Le Labyrinthe',
      'favicon':null,
      'mode': 'site',
      'ffo':'LB',
      'formbutton': '',
      'url': 'https://booking.lelabyrinthe.be/',
      'urlhash': '317e5d1d777250b5764c2ec8fcfa55868bd2c89d55006064f1820d9bfe1d1338',
      'promoCode': '',
      'privacyLink':{},
      'proposeVoucherPayment':true,
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://www.lelabyrinthe.be/en/guide-pratique/horaires-tarifs/',
          'nl': 'https://www.lelabyrinthe.be/nl/guide-pratique/horaires-tarifs/',
          'fr': 'https://www.lelabyrinthe.be/guide-pratique/horaires-tarifs/'
        }
      }],
      'finishedRedirect': {
        'en':'https://www.lelabyrinthe.be/en/confirmed',
        'nl':'https://lelabyrinthe.be/nl/bevestiging',
        'fr':'https://www.lelabyrinthe.be/confirmation'
      },
      'logo': {
        'alt':'Logo Le Labyrinthe',
        'src':'/assets/images/logo-lelabyrinthe.svg',
        'href':{'en':'https://www.lelabyrinthe.be/en','nl':'https://www.lelabyrinthe.be/nl','fr':'https://www.lelabyrinthe.be'}
      },
      'onlineDiscountMessage':{},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.fivenationsdurbuy.be/giftcard/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-5KHF7R4',
        'uidSource':false
      },
      'title':'Booking | Five Nations Durbuy',
      'favicon':'https://www.fivenationsdurbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo': 'FG',
      'formbutton': '',
      'url': 'https://booking.fivenationsdurbuy.be/giftcard/',
      'urlhash': 'a97b0ee4f80e8e76fea40c03b5e9249b99445eb62470a1ccfbb2b4f71ed752f5',
      'promoCode': '',
      'skipDatesPage':true,
      'termsAndConditionsLinks': [{
        'label': {
          'en': 'the terms and conditions',
          'nl': 'de algemene voorwaarden',
          'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href': {
          'en': 'https://www.fivenationsdurbuy.be/en/mentions-legales',
          'nl': 'https://www.fivenationsdurbuy.be/nl/mentions-legales',
          'fr': 'https://www.fivenationsdurbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink': {
        'label': {'en': 'privacy', 'nl': 'privacy', 'fr': 'vie priv\u00E9e'},
        'href': {
          'en': 'https://www.fivenationsdurbuy.be/en/gdpr',
          'nl': 'https://www.fivenationsdurbuy.be/nl/gdpr',
          'fr': 'https://www.fivenationsdurbuy.be/fr/gdpr'
        }
      },
      'proposeVoucherPayment': true,
      'proposePromotionPayment': true,
      'finishedRedirect': {
        'en': 'https://www.fivenationsdurbuy.be/en/confirmation',
        'nl': 'https://www.fivenationsdurbuy.be/nl/bevestiging',
        'fr': 'https://www.fivenationsdurbuy.be/fr/confirmation'
      },
      'logo': {
        'alt':'Logo Fivenations',
        'src':'/assets/images/logo-fivenations.svg',
        'href':{'en':'https://www.fivenationsdurbuy.be/en','nl':'https://www.fivenationsdurbuy.be/nl','fr':'https://www.fivenationsdurbuy.be/fr'}
      },
      'onlineDiscountMessage': {'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.saintamour.be/giftcard/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-WHQWJR3',
        'uidSource':false
      },
      'title':'Booking | Saint-Amour',
      'favicon':'https://saintamour.be/wp-content/uploads/2017/05/cropped-favicon-1-32x32.png',
      'mode': 'site',
      'ffo':'AG',
      'formbutton': '',
      'skipDatesPage':true,
      'url': 'https://booking.saintamour.be/giftcard/',
      'urlhash': '93e1abf5a3d1d39ab0f9de422dc5342b362da39ac72013946aea9786097f14bb',
      'promoCode': '',
      'termsAndConditionsLinks': [{
        'label': {
          'en': 'the terms and conditions',
          'nl': 'de algemene voorwaarden',
          'fr': 'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href': {
          'en': 'https://www.saintamour.be/en/privacy-terms-and-conditions',
          'nl': 'https://www.saintamour.be/nl/privacy-algemene-voorwaarden',
          'fr': 'https://www.saintamour.be/fr/vie-privee-conditions-generales'
        }
      }],
      'privacyLink': {
        'label': {'en': 'privacy', 'nl': 'privacy', 'fr': 'vie priv\u00E9e'},
        'href': {
          'en': 'https://www.saintamour.be/en/privacy-terms-and-conditions',
          'nl': 'https://www.saintamour.be/nl/privacy-algemene-voorwaarden',
          'fr': 'https://www.saintamour.be/fr/vie-privee-conditions-generales'
        }
      },
      'proposeVoucherPayment': true,
      'finishedRedirect': {'en':'https://www.saintamour.be/en','nl':'https://www.saintamour.be/nl','fr':'https://www.saintamour.be/fr'},
      'logo': {
        'alt':'Logo Saint-Amour',
        'src':'/assets/images/logo-saintamour.svg',
        'href':{'en':'https://www.saintamour.be/en','nl':'https://www.saintamour.be/nl','fr':'https://www.saintamour.be/fr'}
      },
      'onlineDiscountMessage': {'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.sanglier-durbuy.be/giftcard/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-PQ2VT6V',
        'uidSource':false
      },
      'title':'Booking | Sanglier Durbuy',
      'favicon':'https://www.sanglier-durbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo':'SG',
      'formbutton': '',
      'skipDatesPage':true,
      'url': 'https://booking.sanglier-durbuy.be/giftcard/',
      'urlhash': '3090676935d85370e0e6bcb16c4dd256528da9b5ee2d684a267422c5da7cc556',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://sanglier-durbuy.be/en/disclaimer',
          'nl': 'https://sanglier-durbuy.be/nl/juridische-vermeldingen',
          'fr': 'https://sanglier-durbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://sanglier-durbuy.be/en/cookies',
          'nl': 'https://sanglier-durbuy.be/nl/cookies',
          'fr': 'https://sanglier-durbuy.be/fr/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://sanglier-durbuy.be/en/gift-voucher-confirmation',
        'nl': 'https://sanglier-durbuy.be/nl/bevestiging-cadeaubon',
        'fr': 'https://sanglier-durbuy.be/fr/confirmation-bon-cadeau'
      },
      'logo': {
        'alt':'Logo Sanglier',
        'src':'/assets/images/logo-sd.svg',
        'href':{
          'en':'https://sanglier-durbuy.be/en',
          'nl':'https://sanglier-durbuy.be/nl',
          'fr':'https://sanglier-durbuy.be/fr'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.sanglier-durbuy.be/wellness/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-PQ2VT6V',
        'uidSource':false
      },
      'title':'Booking | Wellness Sanglier Durbuy',
      'favicon':'https://www.sanglier-durbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo':'SW',
      'formbutton': '',
      'skipDatesPage':false,
      'url': 'https://booking.sanglier-durbuy.be/wellness/',
      'urlhash': '57aec35cbdd9dc77e0b5a8e0cf402174f07f6490ce5481b727bee3d8d43ae45f',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://sanglier-durbuy.be/en/disclaimer',
          'nl': 'https://sanglier-durbuy.be/nl/juridische-vermeldingen',
          'fr': 'https://sanglier-durbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://sanglier-durbuy.be/en/cookies',
          'nl': 'https://sanglier-durbuy.be/nl/cookies',
          'fr': 'https://sanglier-durbuy.be/fr/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://sanglier-durbuy.be/en/gift-voucher-confirmation',
        'nl': 'https://sanglier-durbuy.be/nl/bevestiging-cadeaubon',
        'fr': 'https://sanglier-durbuy.be/fr/confirmation-bon-cadeau'
      },
      'logo': {
        'alt':'Logo Sanglier',
        'src':'/assets/images/logo-sd.svg',
        'href':{
          'en':'https://sanglier-durbuy.be/en',
          'nl':'https://sanglier-durbuy.be/nl',
          'fr':'https://sanglier-durbuy.be/fr'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.sanglier-durbuy.be/brunch/': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-PQ2VT6V',
        'uidSource':false
      },
      'title':'Booking | Brunch Sanglier Durbuy',
      'favicon':'https://www.sanglier-durbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo':'SB',
      'formbutton': '',
      'skipDatesPage':false,
      'url': 'https://booking.sanglier-durbuy.be/brunch/',
      'urlhash': '3dbdf36aac8db12b88d15fc81aa4fe5bb26e93365dd9d29af4cb7f5a2fe09fd0',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://sanglier-durbuy.be/en/disclaimer',
          'nl': 'https://sanglier-durbuy.be/nl/juridische-vermeldingen',
          'fr': 'https://sanglier-durbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://sanglier-durbuy.be/en/cookies',
          'nl': 'https://sanglier-durbuy.be/nl/cookies',
          'fr': 'https://sanglier-durbuy.be/fr/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://sanglier-durbuy.be/en/gift-voucher-confirmation',
        'nl': 'https://sanglier-durbuy.be/nl/bevestiging-cadeaubon',
        'fr': 'https://sanglier-durbuy.be/fr/confirmation-bon-cadeau'
      },
      'logo': {
        'alt':'Logo Sanglier',
        'src':'/assets/images/logo-sd.svg',
        'href':{
          'en':'https://sanglier-durbuy.be/en',
          'nl':'https://sanglier-durbuy.be/nl',
          'fr':'https://sanglier-durbuy.be/fr'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'SINGL':defaultPredateSelectors.SINGL}
    },
    'booking.sanglier-durbuy.be': {
      'serviceUrl':'https://outdoor.lapetitemerveille.be/services/index.php',
      'imageService':'https://outdoor.lapetitemerveille.be/services/templateimage.php',
      'defaultLang':'fr',
      'gtm':{
        'primaryURL':'https://www.googletagmanager.com',
        'fallbackURL':'https://www.googletagmanager.com',
        'scriptId':'gtm',
        'queryParams':'id=GTM-PQ2VT6V',
        'uidSource':false
      },
      'title':'Booking | Sanglier Durbuy',
      'favicon':'https://www.sanglier-durbuy.be/sites/default/themes/custom/wdi_theme/favicon.ico',
      'mode': 'site',
      'ffo':'SD',
      'formbutton': '',
      'skipDatesPage':false,
      'url': 'https://booking.sanglier-durbuy.be/',
      'urlhash': '3647f8092ec00ae17cd7fb9a2eb202c6c572dcd32d7e37c68fc16b5cfcc99d6e',
      'promoCode': '',
      'termsAndConditionsLinks':[{
        'label':{
          'en':'the terms and conditions',
          'nl':'de algemene voorwaarden',
          'fr':'les conditions g\u00E9n\u00E9rales et mentions l\u00E9gales'
        },
        'href':{
          'en': 'https://sanglier-durbuy.be/en/disclaimer',
          'nl': 'https://sanglier-durbuy.be/nl/juridische-vermeldingen',
          'fr': 'https://sanglier-durbuy.be/fr/mentions-legales'
        }
      }],
      'privacyLink':{
        'label':{'en':'privacy','nl':'privacy','fr':'vie priv\u00E9e'},
        'href':{
          'en': 'https://sanglier-durbuy.be/en/cookies',
          'nl': 'https://sanglier-durbuy.be/nl/cookies',
          'fr': 'https://sanglier-durbuy.be/fr/cookies'
        }
      },
      'proposeVoucherPayment':true,
      'finishedRedirect': {
        'en': 'https://sanglier-durbuy.be/en/gift-voucher-confirmation',
        'nl': 'https://sanglier-durbuy.be/nl/bevestiging-cadeaubon',
        'fr': 'https://sanglier-durbuy.be/fr/confirmation-bon-cadeau'
      },
      'logo': {
        'alt':'Logo Sanglier',
        'src':'/assets/images/logo-sd.svg',
        'href':{
          'en':'https://sanglier-durbuy.be/en',
          'nl':'https://sanglier-durbuy.be/nl',
          'fr':'https://sanglier-durbuy.be/fr'
        }
      },
      'onlineDiscountMessage':{'en':'reduction on activities when paid online','nl':'korting op activiteiten indien u online betaalt','fr':'de r\u00E9duction sur des activit\u00E9s si vous payez en ligne'},
      'predateSelectors':{'MULTI':defaultPredateSelectors.MULTI}
    }
  };
  this.host=null;
  this.langs=['fr','nl','en'];
  // The venues and the backend keep Brussels time, whatever the browser's.
  this.timeZone='Europe/Brussels';
};
config.prototype.get = function(key) {
  var host=this.getHost();
  return host[key];
};
config.prototype.set = function(key,value) {
  var host=this.getHost();
  host[key]=value;
};
config.prototype.exists = function(key) {
  var host=this.getHost();
  return host.hasOwnProperty(key);
};
config.prototype.browserLang = function() {
  try {
    return new Intl.Locale(this.$window.navigator.language).language;
  } catch (e) {
    // An empty or malformed language tag means the browser states no language.
    if(e instanceof RangeError) {
      return null;
    }
    throw e;
  }
};
// The explicit choices in the order given, else the browser's language, else
// the host default, else the first language; a candidate counts only if it is
// in langs.
config.prototype.resolveLang = function() {
  var langs=this.langs;
  var explicitLangs=Array.prototype.slice.call(arguments);
  return explicitLangs.concat([this.browserLang(),this.get('defaultLang'),langs[0]]).filter(function(lang) {
    return langs.indexOf(lang)!==-1;
  })[0];
};
config.prototype.matchesReferrerUrl = function(referrer) {
  if(!this.exists('referrerUrl')) {
    return true;
  }
  var referrerUrl=this.get('referrerUrl');
  if(angular.isArray(referrerUrl)) {
    return referrerUrl.indexOf(referrer)!==-1;
  }
  return referrerUrl===referrer;
};
config.prototype.getHost = function() {
  if(this.host===null) {
    var hostname=this.$window.location.hostname;
    if(hostname.match(/^www\./)) {
      hostname=hostname.substr(4);
    }
    var pathname=this.$window.location.pathname;
    if(hostname+pathname in this.hosts) {
      hostname+=pathname;
    }
    if(hostname in this.hosts) {
      this.host=this.hosts[hostname];
      var i;
      for(i in this.$window.outdoorArgs) {
        this.host[i]=this.$window.outdoorArgs[i];
      }
    } else {
      this.$log.log('ERROR: domain <'+hostname+'> is not configured');
    }
  }
  return this.host;
};
angular.module('app').service('config',['$window','$log',config]);
